import React from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { TOPUP_CVV_POPUP } from 'apps/auth/constants/ComponentNames';

const TopUpCardRestriction = ({ popupRef = null, ...props }) => {
    const { icon } = props;

    const onClickHandlerContinue = (e) => {
        e.preventDefault();
        popupRef?.current?.close();
        props.setPopup(TOPUP_CVV_POPUP);
        popupRef.current?.open();
    };
    return (
        <>
            <SimplePopup text={<DangerouslyHtml dangerouslyHtml={props.topUpMessageInfo} />} popupRef={popupRef}>
                <PopupButton href={props.backLink} iconName={icon} text={props.topUpButtonBackText} />
                <PopupButton iconName="arrow-forward" text={props.continue} onClick={onClickHandlerContinue} />
            </SimplePopup>
        </>
    );
};

TopUpCardRestriction.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }),
};

const mapStateToProps = (state) => {
    return {
        backLink: state.extra.backLink,
        topUpMessageInfo: state.messages.pageMessages.topUpMessageInfo,
        topUpButtonBackText: state.messages.pageMessages.topUpButtonBackText,
        continue: state.messages.pageMessages.continue,
    };
};
export default connect(mapStateToProps)(TopUpCardRestriction);
